import React from 'react';
import { motion } from 'framer-motion';
interface PageTransitionProps {
  children: React.ReactNode;
  type?: 'fade' | 'slideUp' | 'slideRight' | 'slideLeft';
}
const variants = {
  fade: {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    transition: {
      duration: 0.28,
      ease: 'easeOut'
    }
  },
  slideUp: {
    initial: {
      opacity: 0,
      y: 16
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.28,
      ease: 'easeOut'
    }
  },
  slideRight: {
    initial: {
      opacity: 0,
      x: -16
    },
    animate: {
      opacity: 1,
      x: 0
    },
    transition: {
      duration: 0.28,
      ease: 'easeOut'
    }
  },
  slideLeft: {
    initial: {
      opacity: 0,
      x: 16
    },
    animate: {
      opacity: 1,
      x: 0
    },
    transition: {
      duration: 0.28,
      ease: 'easeOut'
    }
  }
};
export function PageTransition({
  children,
  type = 'slideUp'
}: PageTransitionProps) {
  const v = variants[type];
  return <motion.div initial={v.initial} animate={v.animate} transition={v.transition} style={{
    willChange: 'transform, opacity'
  }} className="w-full h-full" data-id="element-304" data-mp="1mkgdm1rttr6m">
      {children}
    </motion.div>;
}